// import getBaseData from '@/utils/get-base-data'
import axios, { AxiosRequestConfig } from 'axios'
import dayjs from 'dayjs'
import { $alert } from '@/components/installer/defaultAlert'
import { getToken, doNativeEncrypt, doNativeDecrypt, refreshPubKey } from '@/utils/navitiveApi/common'
const flag = false

const filteUrl = [
    '/web/agreement/queryAgreement/plaintext'
]

export interface MyResponseType<T = any> {
    code: 9000 | number
    message: string
    data: T
}

const responseCode = {
    // 请求成功
    SUCCESS: 200,
    DETAULT_ERROR: 400,
}

const showResState = (state: number) => {
    let message = ''
    // 这里只做部分常见的示例，具体根据需要进行配置
    switch (state) {
        case 400:
            message = '请求错误(400)'
            break
        case 401:
            message = '未授权，请重新登录(401)'
            break
        case 403:
            message = '拒绝访问(403)'
            break
        case 404:
            message = '请求出错(404)'
            break
        case 500:
            message = '服务器错误(500)'
            break
        case 501:
            message = '服务未实现(501)'
            break
        case 502:
            message = '网络错误(502)'
            break
        case 503:
            message = '服务不可用(503)'
            break
        default:
            message = `连接出错(${state})!`
    }
    return message
}

const instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    // baseURL: 'https://estationdownload.sinosig.com:1443/lmes',
    // baseURL: '/api',
    timeout: 300000,
})

// 设置post请求头
// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
    async (config: AxiosRequestConfig) => {
        const { method } = config
        config.headers = config.headers || {}
        // 从cookie获取token
        // config.headers['token'] = getBaseData().info.loginToken

        // 本地项目携带token
        // if (process.env.VUE_APP_MODE_NAME === 'local') {
        //     config.headers['token'] =
        //         'NlTUqwAyy%2BsBep0bWpbvVfzFkF3E5KZLhLA%2FzUXzx3hqzAZh6a%2BZkd1by8C0RfYZ'
        // } else {
        //     config.headers['token'] = getToken() || ''
        // }
        if (process.env.VUE_APP_MODE_NAME === 'local') {
            config.headers['token'] = 'J9AMGVQwoQIVlcWAxCbJNM3Gh8mSqS7FkvvR87yaxeTKFiPNuCGMkcMK7wVRVUQi'
        } else {
            try {
                // 阳光保险隐私协议-不加密接口不携带token
                const cUrl = config.url || ''
                if (['/web/agreement/queryAgreement/plaintext'].includes(cUrl)) {
                    console.warn('不加密接口不携带token')
                } else {
                    const _token: any = await getToken().catch(e => {
                        console.warn('获取token失败')
                    })
                    config.headers['token'] = _token
                }
            } catch (e) {
                console.warn('获取token失败')
            }
        }
        let apiData
        // post 方法统一用json格式传数据
        if (method === 'get' || method === 'put') {
            config.headers['content-type'] = 'application/json;charset=utf-8'
            if (config['params']) {
                config['params']['timeForH5'] = new Date().getTime() + Math.floor(Math.random() * 10)
            }
            apiData = JSON.stringify(config.params) || ''
        }
        if (method === 'post') {
            config.headers['content-type'] = 'application/json;charset=utf-8'
            apiData = JSON.stringify(config.data) || ''
        }
        const url = config.url as string
        console.info('url', url, 'filteUrl.indexOf(url)', filteUrl.indexOf(url) > -1)
        if ((process.env.VUE_APP_IS_ENCRYPT=='true') && !(filteUrl.indexOf(url) > -1)) {
            // 调用原生方法对参数加密
            try {
                const str: any = await doNativeEncrypt(apiData)
                const obj = JSON.parse(str)
                console.info('加密key', obj.xkey)
                // 缓存xKey
                window.sessionStorage.setItem('xkey', obj.xkey)
                // 添加请求头
                config.headers['key'] = obj.encryptenKey
                // 参数加密 get 不处理
                if (method === 'get') {
                    // config.params = str.encryptedString
                } else if (method === 'post') {
                    config.data = obj.encryptedString
                }
            } catch (e) {
                console.warn('加密参数失败')
            }
        }
        return config
    },
    (error: any) => {
        return Promise.reject(error)
    },
)

// 响应拦截器
instance.interceptors.response.use(
    async response => {
        const url = response.config.url || ''
        const result = response.data
        const code = Number(result.code)
        console.info('response', response)
        console.info('url', url, 'filteUrl.indexOf(url)', filteUrl.indexOf(url) > -1)
        if (response.status === responseCode.SUCCESS) {
            if ((process.env.VUE_APP_IS_ENCRYPT=='true') && !(filteUrl.indexOf(url) > -1)) {
                if (code === 9000) {
                    const xkey = window.sessionStorage.getItem('xkey') || ''
                    const obj = {
                        content: result.data,
                        xkey,
                    }
                    // 进行解密处理
                    try {
                        console.info('解密 key', xkey, 'content', result.data.substr(0, 10))
                        const _result: any = await doNativeDecrypt(JSON.stringify(obj))
                        // console.info('原生方法 解密结果', _result)
                        response.data.data = JSON.parse(_result)
                        return response
                    } catch (e) {
                        // console.info('接口返回的结果 调用原生方法解密失败 或JSON.parse原生解密结果失败不需要再转成JSON')
                        const _result: any = await doNativeDecrypt(JSON.stringify(obj))
                        // console.info('原生方法 解密结果', _result)
                        response.data.data = _result
                        return response
                    }
                } else if (code === 9011) {
                    const _code: any = await refreshPubKey()
                    // console.info('接口返回9011, 调用原生方法重新获取加密公钥, 原生返回的刷新公钥结果: ', _code)
                    if (_code.toString() === '1') {
                        return await restry(response)
                    }
                }
            }
            return response
        } else {
            const time = dayjs(new Date()).format('YYYYMMDDHHmm')
            const arr = url.split('/')
            const requestUrl = arr[arr.length - 1]

            $alert({
                message: `非常抱歉，系统异常，请全屏截图上报运维平台解决。(${showResState(
                    response.status,
                )}/${requestUrl}；${time})`,
            })
            return Promise.reject(response)
        }
    },
    error => {
        const url = error.config.url
        const status = error.response.status
        const time = dayjs(new Date()).format('YYYYMMDDHHmm')
        const arr = url.split('/')
        const requestUrl = arr[arr.length - 1]

        $alert({
            message: `非常抱歉，系统异常，请全屏截图上报运维平台解决。(${showResState(status)}/${requestUrl}；${time})`,
        })
        return Promise.reject(error)
    },
)

const axiosInstance = async <T = any>(config: AxiosRequestConfig): Promise<MyResponseType<T>> => {
    try {
        const { data } = await instance.request<MyResponseType<T>>(config)
        return data
    } catch (err: any) {
        const message = err.message || '请求失败'
        return {
            code: -1,
            message,
            data: null as any,
        }
    }
}

function restry(err: { config: AxiosRequestConfig<any> }) {
    const back = new Promise(resolve => {
        console.info('接口', err.config.url, '请求失败, 重新请求')
        resolve(null)
    })
    return back.then(() => {
        return instance(err.config)
    })
}

export default axiosInstance
